<template>
    <Particles
        id="tsparticles"
        style="z-index: -1;"
        class="w-screen h-screen top-0 left-0 fixed"
        :particlesInit="particlesInit"
        :particlesLoaded="particlesLoaded"
        :options="{
                    background: {
                        color: {
                            value: '#f3f4f6'
                        }
                    },
                    fpsLimit: 120,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: false,
                                mode: 'push'
                            },
                            onHover: {
                                enable: true,
                                mode: 'grab'
                            },
                            resize: true
                        },
                        modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40
                            },
                            push: {
                                quantity: 4
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4
                            },
                            connect: {
                                distance: 80,
                                lineLinked: {
                                  opacity: 0.5
                                },
                                radius: 60
                            },
                            grab: {
                              distance: 250,
                            }
                        }
                    },
                    particles: {
                        color: {
                            value: '#fff'
                        },
                        links: {
                            color: '#fff',
                            distance: 200,
                            enable: true,
                            opacity: 0.5,
                            width: 1
                        },
                        collisions: {
                            enable: true
                        },
                        move: {
                            direction: 'none',
                            enable: true,
                            outModes: {
                                default: 'bounce'
                            },
                            random: false,
                            speed: 1,
                            straight: false
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800
                            },
                            value: 30
                        },
                        opacity: {
                            value: 0.5
                        },
                        shape: {
                            type: 'circle'
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        },
                    },
                    detectRetina: true
                }"
    />
</template>

<script>
export default {
    name: "ParticleBackground",
    methods: {
        particlesInit(){

        },
        particlesLoaded(){

        }
    }
}
</script>

<style scoped>

</style>
